import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendFormDataRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors.ts';

export const useUploadEventContributorProfilePhotoMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ contributorId, file }: { contributorId: string; file: File }) => {
      const token = await getToken();
      return uploadEventContributorProfilePhoto({ contributorId, file }, token ?? '');
    },
    onSuccess: async () => {
      // Invalidate event contributors query to refresh the data
      await queryClient.invalidateQueries({ queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY] });
    },
  });
};

const uploadEventContributorProfilePhoto = async (
  { contributorId, file }: { contributorId: string; file: File },
  token: string,
) => {
  const url = `${import.meta.env.VITE_API_URL}/contributors/${contributorId}/profile-photo`;
  const formData = new FormData();
  formData.append('photo', file);
  return sendFormDataRequest({
    url,
    method: METHOD.POST,
    body: formData,
    token,
  });
};

export default useUploadEventContributorProfilePhotoMutation;
